module.exports = __webpack_public_path__ + "assets/img/西北.bffb2bc6.jpg";